import styled from "styled-components";

export const OrderFilterButton = styled.button`
  background-color: #fff;
  border: none;
  font-size: 20px;
`;
